import Link from "next/link";
import styled from "styled-components";
import Img from "./img";

const Arrow = () => {
  return (
    <div className="arrow">
      <Img className="light-icon" src="/images/svg/arrow-link-dark.svg" />
      <Img className="dark-icon" src="/images/svg/arrow-link.svg" />
    </div>
  );
};

export const Footer = () => {
  return (
    <Wrapper className="footer same-color" data-testid="footer-container">
      <div className="main">
        <section>
          <h4>Help</h4>
          <Links>
            <li>
              <Link href="/guides" data-testid="footer-link-help-center">
                Help center
                <Arrow />
              </Link>
            </li>
            <li>
              <Link href="/privacy-policy" data-testid="footer-link-privacy">
                Privacy policy
                <Arrow />
              </Link>
            </li>
            <li>
              <Link href="/sellwild-buyer-guarantee" data-testid="footer-link-buyer-guarantee">
                Buyer guarantee
                <Arrow />
              </Link>
            </li>
            <li>
              <Link href="/prohibited-items" data-testid="footer-link-prohibited-items">
                Prohibited items
                <Arrow />
              </Link>
            </li>
            <li>
              <Link href="/privacy-policy" data-testid="footer-link-terms">
                Terms and conditions
                <Arrow />
              </Link>
            </li>
          </Links>
        </section>
        <section>
          <h4>About</h4>
          <Links>
            <li>
              <Link href="/about-us" data-testid="footer-link-about">
                About Sellwild
                <Arrow />
              </Link>
            </li>
            <li>
              <Link href="/partners" data-testid="footer-link-partners">
                Partner Sites <Arrow />
              </Link>
            </li>
            <li>
              <Link href="/investors" data-testid="footer-link-investors">
                Investors
                <Arrow />
              </Link>
            </li>
          </Links>
        </section>
        <section>
          <h4>Shop</h4>
          <Links>
            <li>
              <Link href="/" data-testid="footer-link-newest">
                Newest
                <Arrow />
              </Link>
            </li>
            <li>
              <Link href="/browse/vehicles" data-testid="footer-link-vehicles">
                Vehicles
                <Arrow />
              </Link>
            </li>
            <li>
              <Link href="/browse/electronics" data-testid="footer-link-electronics">
                Electronics
                <Arrow />
              </Link>
            </li>
            <li>
              <Link href="/browse/fashion" data-testid="footer-link-fashion">
                Fashion
                <Arrow />
              </Link>
            </li>
          </Links>
        </section>
        <section>
          <h4>Selling</h4>
          <Links>
            <li>
              <Link href="/sell" data-testid="footer-link-sell">
                Sell on Sellwild
                <Arrow />
              </Link>
            </li>
            <li>
              <Link href="/faq" data-testid="footer-link-faq">
                F.A.Q.
                <Arrow />
              </Link>
            </li>
            <li>
              <Link href="/learn-more" data-testid="footer-link-learn-more">
                Learn More
                <Arrow />
              </Link>
            </li>
          </Links>
        </section>
        <section>
          <h4 className="contact-us-heading">Contact Us</h4>
          <Email>
            <p className="email-flex">
              <svg
                width="23"
                height="18"
                viewBox="0 0 23 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20.9785 0H2.02148C0.90823 0 0 0.907242 0 2.02148V15.498C0 16.6085 0.904188 17.5195 2.02148 17.5195H20.9785C22.089 17.5195 23 16.6153 23 15.498V2.02148C23 0.911016 22.0958 0 20.9785 0ZM20.6994 1.34766L11.5429 10.5042L2.30714 1.34766H20.6994ZM1.34766 15.219V2.29412L7.83792 8.72872L1.34766 15.219ZM2.30058 16.1719L8.79494 9.67752L11.0705 11.9336C11.334 12.1948 11.7591 12.1939 12.0214 11.9315L14.2402 9.71269L20.6994 16.1719H2.30058ZM21.6523 15.2189L15.1932 8.75977L21.6523 2.30054V15.2189Z"
                  fill="currentColor"
                />
              </svg>

              <a href="mailto:support@sellwild.com" data-testid="footer-email-link">support@sellwild.com</a>
            </p>
          </Email>
          <h4>Social Media</h4>
          <SocialLinks>
            <li>
              <a
                data-platform="facebook"
                data-testid="footer-social-facebook"
                href="https://www.facebook.com/SellwildClassifieds"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span>facebook</span>
              </a>
            </li>
            <li>
              <a
                data-platform="instagram"
                data-testid="footer-social-instagram"
                href="https://www.instagram.com/sellwild/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span>instagram</span>
              </a>
            </li>
            <li>
              <a
                data-platform="twitter"
                data-testid="footer-social-twitter"
                href="https://twitter.com/Sellwild"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span>twitter</span>
              </a>
            </li>
          </SocialLinks>
        </section>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.footer`
  position: relative;
  z-index: 0;
  margin-top: 100px;

  // RESPONSIVE GAP
  // 25px at 500px width
  // 75px at 1500px width
  --gap: clamp(25px, 5vw, 75px);

  .main {
    padding: 66px var(--gap);
    margin: auto;
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    gap: var(--gap);
    max-width: 1200px;
    width: 100%;
    padding-bottom: 170px;

    @media (max-width: 1439px) {
      flex-wrap: wrap;
      padding-top: 24px;
    }

    section {
      flex: 1 1 220px;
    }

    section:last-child {
      flex: 1 0 320px;
    }

    h4 {
      font-family: "Avenir Next";
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 32px;
      margin: 0;
    }

    ul {
      padding: 0;
      list-style-type: none;
    }

    a {
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
    .email-flex {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      svg {
        margin-right: 10px;
      }
    }
  }
`;

const Links = styled.ul`
  li {
    font-family: "Avenir Next";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 32px;
    border-top: 1px solid #718cbb;
    white-space: nowrap;

    a {
      display: block;
      padding: 10px;
      padding-right: 36px;
      padding-left: 0;
      position: relative;
    }

    .arrow {
      height: 16px;
      width: 16px;
      right: 10px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }
`;

const Email = styled.div`
  padding: 0px;
  padding-left: 0px;
  border-bottom: 1px solid #718cbb;
  margin-bottom: 18px;
  position: relative;

  a {
    font-family: "Avenir Next";
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 32px;
    // color: #fff;
  }
`;

const SocialLinks = styled.ul`
  display: flex;
  flex-direction: row;
  padding: 10px;
  gap: 18px;

  li {
    a {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 23px;
      width: 46px;
      height: 46px;

      background: linear-gradient(180deg, #6c8554 0%, #6d8762 100%);
      border: 1px solid #bdc75f;
      box-shadow:
        0px 4px 4px rgba(29, 38, 39, 0.35),
        inset 0px 6px 4px rgba(0, 0, 0, 0.25);
      cursor: pointer;
    }

    a[data-platform="facebook"]:after {
      content: url(https://public.sellwild.com/images/svg/facebook.svg);
      height: 19px;
    }

    a[data-platform="twitter"]:after {
      content: url(https://public.sellwild.com/images/svg/twitter.svg);
      height: 17px;
    }

    a[data-platform="instagram"]:after {
      content: url(https://public.sellwild.com/images/svg/instagram.svg);
      height: 21px;
    }

    span {
      position: absolute;
      left: -9999px;
      top: auto;
      width: 1px;
      height: 1px;
      overflow: hidden;
    }
  }
`;
